/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M9.549 11.2129c.2906-.2774.2906-.7273 0-1.0048-.2908-.2775-.762-.2775-1.0528 0L4 14.5l4.4962 4.2919c.2907.2775.762.2775 1.0527 0 .2907-.2775.2907-.7274 0-1.0048L6.1054 14.5l3.4435-3.2871ZM14.4511 18.7919c-.2907-.2775-.2907-.7274 0-1.0048L17.8946 14.5l-3.4435-3.2871c-.2907-.2774-.2907-.7273 0-1.0048.2907-.2775.762-.2775 1.0527 0L20 14.5l-4.4962 4.2919c-.2907.2775-.762.2775-1.0527 0Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 4c0-1.6568 1.3432-3 3-3h18c1.6569 0 3 1.3432 3 3v16c0 1.6569-1.3431 3-3 3H3c-1.6568 0-3-1.3431-3-3V4Zm3-1.5h18c.8284 0 1.5.6716 1.5 1.5v2.25h-21V4c0-.8284.6716-1.5 1.5-1.5ZM1.5 7.75V20c0 .8284.6716 1.5 1.5 1.5h18c.8284 0 1.5-.6716 1.5-1.5V7.75h-21Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'OpenProject'
);
